@if (activity) {
  <div
    [ngClass]="
      activity.activityCategory?.isProductiveTime
        ? activity.serviceId
          ? 'service-activity'
          : 'shift-activity'
        : 'unproductive-activity'
    "
    [style.left.px]="leftPx"
    [style.right.px]="rightPx"
    [class.dotted-border]="dottedBorder"
    [class.bg-transparent]="dottedBorder && !isHovered"
    nz-tooltip
    [nzTooltipTitle]="isTooltipVisible() ? tooltipInformation : ''"
    [nzTooltipColor]="'#fff'"
    [nzTooltipMouseEnterDelay]="0.3"
    nzTooltipPlacement="top"
    [nzTooltipOverlayStyle]="{ 'max-width': '450px', 'min-width': '250px' }"
    class="draggable-item"
  >
    <wilson-activity-card-content
      [activity]="activity"
      [calculatedActivityWidth]="calculatedActivityWidth"
      [activityEndTimeDifference]="activityEndTimeDifference"
      [activityEndTimeType]="activityEndTimeType"
    ></wilson-activity-card-content>
  </div>
}

<ng-template #tooltipInformation>
  <wilson-timeline-activity-tooltip
    [activity]="activity"
    [accurateActivityStartDateTime]="accurateActivityStartDateTime"
    [accurateActivityEndDateTime]="accurateActivityEndDateTime"
    [activityStartTimeDifference]="activityStartTimeDifference"
    [activityEndTimeDifference]="activityEndTimeDifference"
    [activityStartTimeType]="activityStartTimeType"
    [activityEndTimeType]="activityEndTimeType"
  >
  </wilson-timeline-activity-tooltip>
</ng-template>
